import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { graphqlClient } from "./client"
import { DEFAULT_SEARCH_LIMIT } from "@/constants/customerSearch"
import {
  Billing_Account_Bool_Exp,
  Complaint_Order_By,
  Cs__Soe_Dashboard_Total_Order_By,
  Customer_Order_By,
  Install_Codes_Order_By,
  GetAccountCreditByCoreIdDocument,
  GetAccountCreditDocument,
  GetAccountsByCustomerIdDocument,
  GetAlpsRangeDocument,
  GetAlpsRangeQueryVariables,
  GetAutoSyncedAccountsCountDocument,
  GetBlacklistedCustomersDocument,
  GetCallTraceAuditDocument,
  GetCardPaymentsDocument,
  GetCasesByCoreIdDocument,
  GetComplaintColumnValuesDocument,
  GetComplaintsDocument,
  GetComplaintsForAccountNumberDocument,
  GetComplaintsQueryVariables,
  GetComplaintsSummaryDocument,
  GetConfigurationDocument,
  GetConfigurationsDocument,
  GetEmailTemplateSummariesDocument,
  GetEmailTemplatesByCommunicationDocument,
  GetExternalEmailTemplatesDocument,
  GetExternalEmailTemplateByIdDocument,
  GetCommunicationsDocument,
  GetCoreIdByAccountNumberDocument,
  GetCreditCheckStatusDocument,
  GetCustomerIdByAccountNumberDocument,
  GetCustomerReferralDetailsDocument,
  GetCustomerReferralDocument,
  GetCustomersDocument,
  GetDcaConfigurationDocument,
  GetElecNominationsDocument,
  GetElecTradesDocument,
  GetElecTradesHistoryDocument,
  GetAdminEmailChartDataDocument,
  GetAdminEmailChartDataQueryVariables,
  GetAdminEmailListDocument,
  GetAdminEmailListQueryVariables,
  GetAdminEmailTemplatesDocument,
  GetAdminEmailTotalCountDocument,
  GetAdminEmailTotalCountQueryVariables,
  GetEmailContentDocument,
  GetEmailsByEmailAddressDocument,
  GetEnrolmentAutomatedCommunicationByIdDocument,
  GetEnrolmentAutomatedCommunicationByIdQueryVariables,
  GetEnrolmentsByBrokerDocument,
  GetEnrolmentsByBrokerQueryVariables,
  GetFreshdeskContactDocument,
  GetFreshdeskContactsDocument,
  GetFreshdeskTicketsDocument,
  GetGasTradesDocument,
  GetGasTradesHistoryDocument,
  GetInstallCodesDocument,
  GetInstallCodesQueryVariables,
  GetJuniferAccountsDocument,
  GetLastMeterReadingsDocument,
  GetMeterReadingsDocument,
  GetMeterReadingsErrorsDocument,
  GetOutboundPhotoRequestDocument,
  GetPaymentReviewIdsDocument,
  GetPaymentReviewLatestIdDocument,
  GetPaymentReviewRecordDocument,
  GetPaymentReviewRecordsDocument,
  GetPaymentReviewRecordsQueryVariables,
  GetPaymentReviewSummaryDocument,
  GetProductsDocument,
  GetRecentCustomerReferralsDocument,
  GetRegistrationCreditChecksByAccountNumberDocument,
  GetRegistrationCreditChecksDocument,
  GetRegistrationCreditChecksQueryVariables,
  GetReminderDocument,
  GetSmartMetersEligibleForExchangeDocument,
  GetSmartMetersEligibleForExchangeQueryVariables,
  GetMeterpointSupplyHistoryDocument,
  GetRtsMetersDocument,
  GetRtsMetersQueryVariables,
  GetSmartChargingAccountsDocument,
  GetSmartChargingEligibilityChecksDocument,
  GetSmartChargingWaitlistDocument,
  GetSmartMeterColumnValuesDocument,
  GetSmartMeterDocument,
  GetSmartMetersDocument,
  GetSmartMetersQueryVariables,
  GetSmartMetersSummaryDocument,
  GetSyncedAccountsNumbersDocument,
  GetUserAccountNumbersDocument,
  GetUsersDocument,
  Junifer__Account_Bool_Exp,
  Junifer__Account_Order_By,
  MeterpointsByIdsDocument,
  MeterpointsByIdsQueryVariables,
  Registration_Credit_Check_Order_By,
  SearchFreshdeskContactsDocument,
  SearchFreshdeskContactsQueryVariables,
  Users_Order_By,
  SearchAccountsByPhoneOrEmailDocument,
  SearchAccountsBySurnameDocument,
  SearchAccountsByPostcodeDocument,
  SearchMeterPointsByIdentifierDocument,
  SearchAccountsByMeterPointIdsDocument,
  GetAccountNumbersByCoreIdsDocument,
  GetFindTestAccountsDocument,
  GetUserDocument,
  GetRenewalsByUserIdDocument,
  GetCancellationsByUserIdDocument,
  GetEnrolmentsQueryVariables,
  GetEnrolmentsDocument,
  GetFlexMarketSubscriptionsDocument,
  GetUsersForAccountDocument,
  GetTariffsDocument,
  GetBeFinancialsConfigListDocument,
  GetBeFinancialsConfigStatsDocument,
  GetBeFinancialsConfigHistoryDocument,
  GetBeFinancialsJobsListDocument,
  GetWarrantsJobsDocument,
  GetWarrantsAccountsDocument,
  GetWarrantsAccountsWhitelistDocument,
  GetWarrantsAccountsHistoryDocument,
  GetWarrantsDcaQueueDocument,
  GetWarrantsDcaTicketsDocument,
  GetWarrantsCommunicationGroupsDocument,
  GetWarrantsCommunicationsDocument,
  GetWarrantsFilesJobsDocument,
  GetWarrantsFilesAccountsDocument,
  GetWarrantsFilesProcessedDocument,
  GetWarrantsFilesAccountsSummaryDocument,
  Financials_Warrants_Job_Bool_Exp,
  Financials_Warrants_Job_Order_By,
  Financials_Warrants_Accounts_Bool_Exp,
  Financials_Warrants_Accounts_Order_By,
  Financials_Warrants_Accounts_Whitelist_Bool_Exp,
  Financials_Warrants_Accounts_Whitelist_Order_By,
  Financials_Warrants_Accounts_History_Bool_Exp,
  Financials_Warrants_Accounts_History_Order_By,
  Financials_Warrants_Dca_Queue_Bool_Exp,
  Financials_Warrants_Dca_Queue_Order_By,
  Financials_Warrants_Dca_Tickets_Bool_Exp,
  Financials_Warrants_Dca_Tickets_Order_By,
  Financials_Warrants_Communication_Group_Bool_Exp,
  Financials_Warrants_Communication_Group_Order_By,
  Financials_Warrants_Communications_Bool_Exp,
  Financials_Warrants_Communications_Order_By,
  Financials_Warrants_Files_Job_Bool_Exp,
  Financials_Warrants_Files_Job_Order_By,
  Financials_Warrants_Files_Account_Bool_Exp,
  Financials_Warrants_Files_Account_Order_By,
  Financials_Warrants_Files_Processed_Bool_Exp,
  Financials_Warrants_Files_Processed_Order_By,
  GetInstallCodesSummaryDocument,
  GetMetersByMpxnMsnQueryVariables,
  GetMetersByMpxnMsnDocument,
  GetInstallCodesExtraQueryVariables,
  GetInstallCodesExtraDocument,
  GetActiveDirectDebitAccountsDocument,
} from "./generated/graphql"
import { GetMeterReadingsQueryVariables } from "@/api/hasura/generated/graphql"
import { Configuration } from "@/constants/configuration"
import { formatServerDate, formatServerDateTimeNow } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export const HasuraQueries = createQueryKeyStore({
  account: {
    getActiveDirectDebitAccounts: (billingAccountIds: string[]) => ({
      queryKey: ["activeDirectDebitAccounts", ...billingAccountIds],
      queryFn: () =>
        graphqlClient.request(GetActiveDirectDebitAccountsDocument, {
          billingAccountIds,
          now: formatServerDateTimeNow(),
        }),
    }),
    getCoreIdByAccountNumber: (accountNumber: string) => ({
      queryKey: [accountNumber],
      queryFn: () =>
        graphqlClient.request(GetCoreIdByAccountNumberDocument, {
          accountNumber,
        }),
    }),
    getCustomerIdByAccountNumber: (accountNumber: string) => ({
      queryKey: [accountNumber],
      queryFn: () =>
        graphqlClient.request(GetCustomerIdByAccountNumberDocument, {
          accountNumber,
        }),
    }),
    getAssociatedAccounts: (customerId: number) => ({
      queryKey: [customerId],
      queryFn: () =>
        graphqlClient.request(GetAccountsByCustomerIdDocument, { customerId }),
    }),
    accountCredit: (accountCreditId: string) => ({
      queryKey: [accountCreditId],
      queryFn: () =>
        graphqlClient.request(GetAccountCreditDocument, {
          accountCreditId,
        }),
    }),
    gdprFields: (juniferNumber: string) => ({
      queryKey: [juniferNumber],
      queryFn: () =>
        graphqlClient.request(GetCallTraceAuditDocument, { juniferNumber }),
    }),
    freshdesk: {
      queryKey: null,
      contextQueries: {
        searchContacts: (params: SearchFreshdeskContactsQueryVariables) => ({
          queryKey: [JSON.stringify(params)],
          queryFn: () =>
            graphqlClient.request(SearchFreshdeskContactsDocument, params),
        }),
        contact: (contactId: number) => ({
          queryKey: [contactId],
          queryFn: () =>
            graphqlClient.request(GetFreshdeskContactDocument, {
              contactId,
            }),
        }),
        contacts: (accountNumber: string) => ({
          queryKey: [accountNumber],
          queryFn: () =>
            graphqlClient.request(GetFreshdeskContactsDocument, {
              accountNumber,
            }),
        }),
        tickets: (contactId: string) => ({
          queryKey: [contactId],
          queryFn: () =>
            graphqlClient.request(GetFreshdeskTicketsDocument, {
              contactId,
            }),
        }),
      },
    },
    cases: (coreId: number) => ({
      queryKey: [coreId],
      queryFn: () =>
        graphqlClient.request(GetCasesByCoreIdDocument, {
          coreId: coreId,
        }),
    }),
    complaints: (accountNumber: string) => ({
      queryKey: [accountNumber],
      queryFn: () =>
        graphqlClient.request(GetComplaintsForAccountNumberDocument, {
          accountNumber,
        }),
    }),
    /**
     * Account search queries. All queries with a limit parameter default to {@link DEFAULT_SEARCH_LIMIT}
     * to prevent excessive results that could impact performance.
     */
    search: {
      queryKey: null,
      contextQueries: {
        byPhoneOrEmail: (searchTerm: string, limit = DEFAULT_SEARCH_LIMIT) => ({
          queryKey: [searchTerm, limit],
          queryFn: () =>
            graphqlClient.request(SearchAccountsByPhoneOrEmailDocument, {
              searchTerm: `%${searchTerm}%`,
              limit,
            }),
        }),
        bySurname: (surname: string, limit = DEFAULT_SEARCH_LIMIT) => ({
          queryKey: [surname, limit],
          queryFn: () =>
            graphqlClient.request(SearchAccountsBySurnameDocument, {
              surnamePattern: `%${surname}%`,
              limit,
            }),
        }),
        byPostcode: (postcode: string, limit = DEFAULT_SEARCH_LIMIT) => ({
          queryKey: [postcode, limit],
          queryFn: () =>
            graphqlClient.request(SearchAccountsByPostcodeDocument, {
              postcode: `%${postcode}%`,
              limit,
            }),
        }),
        byMeterPointIdentifier: (
          identifier: string,
          limit = DEFAULT_SEARCH_LIMIT,
        ) => ({
          queryKey: [identifier, limit],
          queryFn: () =>
            graphqlClient.request(SearchMeterPointsByIdentifierDocument, {
              identifier: `${identifier}%`,
              limit,
            }),
        }),
        byMeterPointIds: (meterPointIds: number[]) => ({
          queryKey: [meterPointIds],
          queryFn: () =>
            graphqlClient.request(SearchAccountsByMeterPointIdsDocument, {
              meterPointIds,
            }),
        }),
        getAccountNumbersByCoreIds: (coreIds: number[]) => ({
          queryKey: [coreIds],
          queryFn: () =>
            graphqlClient.request(GetAccountNumbersByCoreIdsDocument, {
              coreIds,
            }),
        }),
      },
    },
  },
  flexMarketSubscription: {
    getSubscriptionsForAccount: (billingAccountId: number) => ({
      queryKey: [billingAccountId],
      queryFn: () =>
        graphqlClient.request(GetFlexMarketSubscriptionsDocument, {
          billingAccountId,
        }),
    }),
  },
  configuration: {
    getConfigurationValue: (configurationName: Configuration) => ({
      queryKey: [configurationName],
      queryFn: () =>
        graphqlClient.request(GetConfigurationDocument, {
          name: configurationName,
          now: formatServerDateTimeNow(),
        }),
    }),
    list: () => ({
      queryKey: ["configurationList"],
      queryFn: () => graphqlClient.request(GetConfigurationsDocument),
    }),
  },
  product: {
    list: () => ({
      queryKey: ["productList"],
      queryFn: () => graphqlClient.request(GetProductsDocument),
    }),
  },
  referral: {
    blacklistedCodes: () => ({
      queryKey: ["blacklistedCodesList"],
      queryFn: () => graphqlClient.request(GetBlacklistedCustomersDocument),
    }),
    customer: (customerId: number) => ({
      queryKey: ["customerReferral", customerId],
      queryFn: () =>
        graphqlClient.request(GetCustomerReferralDocument, { customerId }),
    }),
    customerDetails: (customerNumber: string) => ({
      queryKey: ["customerReferralDetails", customerNumber],
      queryFn: () =>
        graphqlClient.request(GetCustomerReferralDetailsDocument, {
          customerNumber,
        }),
    }),
    recentReferrals: (limit: number) => ({
      queryKey: ["recentReferralsList"],
      queryFn: () =>
        graphqlClient.request(GetRecentCustomerReferralsDocument, { limit }),
    }),
  },
  user: {
    list: (
      search: string,
      offset: number,
      limit: number,
      orderBy: Users_Order_By,
    ) => ({
      queryKey: ["usersList", search, offset, limit, JSON.stringify(orderBy)],
      queryFn: () =>
        graphqlClient.request(GetUsersDocument, {
          search,
          offset,
          limit,
          orderBy,
        }),
    }),
    details: (id: number) => ({
      queryKey: ["user", id],
      queryFn: () => graphqlClient.request(GetUserDocument, { id }),
      contextQueries: {
        renewals: {
          queryKey: null,
          queryFn: () =>
            graphqlClient.request(GetRenewalsByUserIdDocument, {
              userId: id,
            }),
        },
        cancellations: {
          queryKey: null,
          queryFn: () =>
            graphqlClient.request(GetCancellationsByUserIdDocument, {
              userId: id,
            }),
        },
      },
    }),
    getUsersForAccount: (accountId: number) => ({
      queryKey: [accountId],
      queryFn: () =>
        graphqlClient.request(GetUsersForAccountDocument, { accountId }),
    }),
  },
  accountCredit: {
    accountCreditByCoreId: (coreId: number) => ({
      queryKey: [coreId],
      queryFn: () =>
        graphqlClient.request(GetAccountCreditByCoreIdDocument, {
          coreId,
        }),
    }),
  },
  customer: {
    list: (
      search: string,
      offset: number,
      limit: number,
      orderBy: Customer_Order_By,
    ) => ({
      queryKey: [
        "customersList",
        search,
        offset,
        limit,
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetCustomersDocument, {
          search,
          offset,
          limit,
          orderBy,
        }),
    }),
  },
  enrolment: {
    list: (payload: GetEnrolmentsQueryVariables) => ({
      queryKey: [JSON.stringify(payload)],
      queryFn: () => graphqlClient.request(GetEnrolmentsDocument, payload),
    }),
    groupedByBroker: (payload: GetEnrolmentsByBrokerQueryVariables) => ({
      queryKey: ["enrolmentsByBroker", JSON.stringify(payload)],
      queryFn: () =>
        graphqlClient.request(GetEnrolmentsByBrokerDocument, payload),
    }),
    automatedCommunicationById: (
      payload: GetEnrolmentAutomatedCommunicationByIdQueryVariables,
    ) => ({
      queryKey: ["enrolmentAutomatedCommunication", JSON.stringify(payload)],
      queryFn: () =>
        graphqlClient.request(
          GetEnrolmentAutomatedCommunicationByIdDocument,
          payload,
        ),
    }),
  },
  comms: {
    emails: (email: string) => ({
      queryKey: [email],
      queryFn: () =>
        graphqlClient.request(GetEmailsByEmailAddressDocument, {
          email,
        }),
    }),
    emailContent: (path: string) => ({
      queryKey: [path],
      queryFn: () =>
        graphqlClient.request(GetEmailContentDocument, {
          path,
        }),
    }),
    meterReminder: (accountNumber: string) => ({
      queryKey: [accountNumber],
      queryFn: () =>
        graphqlClient.request(GetReminderDocument, {
          accountNumber,
        }),
    }),
  },
  smartMeter: {
    list: (
      search: string,
      offset: number,
      limit: number,
      orderBy: Cs__Soe_Dashboard_Total_Order_By,
      filters: GetSmartMetersQueryVariables,
    ) => ({
      queryKey: [
        "smartMeterList",
        search,
        offset,
        limit,
        JSON.stringify(orderBy),
        JSON.stringify(filters),
      ],
      queryFn: () =>
        graphqlClient.request(GetSmartMetersDocument, {
          search,
          offset,
          limit,
          orderBy,
          ...filters,
        }),
    }),
    summary: () => ({
      queryKey: ["smartMeterSummary"],
      queryFn: () => graphqlClient.request(GetSmartMetersSummaryDocument),
    }),
    columnValues: () => ({
      queryKey: ["smartMeterColumnValues"],
      queryFn: () => graphqlClient.request(GetSmartMeterColumnValuesDocument),
    }),
    getSmartMeter: (mpxn: string) => ({
      queryKey: ["getSmartMeter", mpxn],
      queryFn: () => graphqlClient.request(GetSmartMeterDocument, { mpxn }),
    }),
    getInstallCodes: (
      search: string,
      offset: number,
      limit: number,
      orderBy: Install_Codes_Order_By,
      filters: GetInstallCodesQueryVariables,
    ) => {
      return {
        queryKey: [
          "getInstallCodes",
          search,
          offset,
          limit,
          JSON.stringify(orderBy),
          JSON.stringify(filters),
        ],
        queryFn: () =>
          graphqlClient.request(GetInstallCodesDocument, {
            search,
            offset,
            limit,
            orderBy,
            ...filters,
            today: dayjs().toISOString(),
          }),
      }
    },
    getInstallCodesExtra: (
      search: string,
      offset: number,
      limit: number,
      orderBy: Install_Codes_Order_By,
      filters: GetInstallCodesExtraQueryVariables,
    ) => {
      return {
        queryKey: [
          "getInstallCodesExtra",
          search,
          offset,
          limit,
          JSON.stringify(orderBy),
          JSON.stringify(filters),
        ],
        queryFn: () =>
          graphqlClient.request(GetInstallCodesExtraDocument, {
            search,
            offset,
            limit,
            orderBy,
            ...filters,
            today: dayjs().toISOString(),
          }),
      }
    },
    getInstallCodesSummary: () => {
      const asnExpiryDate = dayjs().add(60, "days").subtract(3, "years")
      return {
        queryKey: ["getInstallCodesSummary"],
        queryFn: () =>
          graphqlClient.request(GetInstallCodesSummaryDocument, {
            asnExpiryDate: formatServerDate(asnExpiryDate),
          }),
      }
    },
    getMetersByMpxnMsn: (filters: GetMetersByMpxnMsnQueryVariables) => {
      return {
        queryKey: ["getMetersByMpxnMsn", JSON.stringify(filters)],
        queryFn: () =>
          graphqlClient.request(GetMetersByMpxnMsnDocument, {
            ...filters,
          }),
      }
    },
  },
  adminComplaint: {
    list: (
      offset: number,
      limit: number,
      orderBy: Complaint_Order_By,
      filters: GetComplaintsQueryVariables,
    ) => ({
      queryKey: [
        "adminComplaintList",
        offset,
        limit,
        JSON.stringify(orderBy),
        JSON.stringify(filters),
      ],
      queryFn: () =>
        graphqlClient.request(GetComplaintsDocument, {
          offset,
          limit,
          orderBy,
          ...filters,
        }),
    }),
    summary: () => ({
      queryKey: ["adminComplaintSummary"],
      queryFn: () => graphqlClient.request(GetComplaintsSummaryDocument),
    }),
    columnValues: () => ({
      queryKey: ["complaintColumnValues"],
      queryFn: () => graphqlClient.request(GetComplaintColumnValuesDocument),
    }),
  },
  creditChecks: {
    getRegistrationCreditChecks: (
      limit: number,
      offset: number,
      orderBy: Registration_Credit_Check_Order_By,
      queryProps: GetRegistrationCreditChecksQueryVariables,
    ) => ({
      queryKey: [
        "getRegistrationCreditChecks",
        limit,
        offset,
        JSON.stringify(orderBy),
        JSON.stringify(queryProps),
      ],
      queryFn: () =>
        graphqlClient.request(GetRegistrationCreditChecksDocument, {
          limit,
          offset,
          orderBy,
          ...queryProps,
        }),
    }),
    getRegistrationCreditChecksByAccountNumber: (account_number: string) => ({
      queryKey: ["getRegistrationCreditChecks", JSON.stringify(account_number)],
      queryFn: () =>
        graphqlClient.request(
          GetRegistrationCreditChecksByAccountNumberDocument,
          {
            account_number,
          },
        ),
    }),
    getRegistrationCreditCheckStatus: (accountNumber: string) => ({
      queryKey: ["getRegistrationCreditCheckStatus", accountNumber],
      queryFn: () =>
        graphqlClient.request(GetCreditCheckStatusDocument, {
          accountNumber,
        }),
    }),
  },
  meterReadings: {
    errors: () => ({
      queryKey: ["meterReadingsErrors"],
      queryFn: () => graphqlClient.request(GetMeterReadingsErrorsDocument),
    }),
    lastErroredMeterReadings: (limit: number, offset: number) => ({
      queryKey: ["lastErroredMeterReadings", limit, offset],
      queryFn: () =>
        graphqlClient.request(GetLastMeterReadingsDocument, { limit, offset }),
    }),
    erroredMeterReadings: (filter: GetMeterReadingsQueryVariables) => ({
      queryKey: ["erroredMeterReadings", JSON.stringify(filter)],
      queryFn: () =>
        graphqlClient.request(GetMeterReadingsDocument, { ...filter }),
    }),
    getOutboundPhotoRequest: (accountNumber: string) => ({
      queryKey: ["getOutboundPhotoRequest", accountNumber],
      queryFn: () =>
        graphqlClient.request(GetOutboundPhotoRequestDocument, {
          accountNumber,
        }),
    }),
  },
  tradingData: {
    elecData: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetElecTradesDocument),
    },
    gasData: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetGasTradesDocument),
    },
    elecHistoryData: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetElecTradesHistoryDocument),
    },
    gasHistoryData: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetGasTradesHistoryDocument),
    },
    elecNominationsData: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetElecNominationsDocument),
    },
  },
  cardPayments: {
    details: (externalId: string) => ({
      queryKey: [externalId],
      queryFn: () =>
        graphqlClient.request(GetCardPaymentsDocument, { externalId }),
    }),
  },

  meterpoints: {
    meterpointsByIds: (meterpointIds: MeterpointsByIdsQueryVariables) => ({
      queryKey: [meterpointIds],
      queryFn: () =>
        graphqlClient.request(MeterpointsByIdsDocument, meterpointIds),
    }),
    supplyHistory: (meterpointId: number) => ({
      queryKey: [meterpointId],
      queryFn: () =>
        graphqlClient.request(GetMeterpointSupplyHistoryDocument, {
          meterpointId,
        }),
    }),
    rtsMeters: (serialNumbers: GetRtsMetersQueryVariables) => ({
      queryKey: [JSON.stringify(serialNumbers)],
      queryFn: () => graphqlClient.request(GetRtsMetersDocument, serialNumbers),
    }),
    smartMetersEligibleForExchange: (
      variables: GetSmartMetersEligibleForExchangeQueryVariables,
    ) => ({
      queryKey: [JSON.stringify(variables)],
      queryFn: () =>
        graphqlClient.request(
          GetSmartMetersEligibleForExchangeDocument,
          variables,
        ),
    }),
  },
  paymentReviews: {
    latestId: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetPaymentReviewLatestIdDocument),
    },
    paymentReviewIds: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetPaymentReviewIdsDocument),
    },
    summary: (paymentReviewId: number) => ({
      queryKey: [paymentReviewId],
      queryFn: () =>
        graphqlClient.request(GetPaymentReviewSummaryDocument, {
          paymentReviewId,
        }),
    }),
    records: (filters: GetPaymentReviewRecordsQueryVariables) => ({
      queryKey: [JSON.stringify(filters)],
      queryFn: () =>
        graphqlClient.request(GetPaymentReviewRecordsDocument, filters),
    }),
    record: (recordId: number) => ({
      queryKey: [recordId],
      queryFn: () =>
        graphqlClient.request(GetPaymentReviewRecordDocument, {
          paymentReviewId: recordId,
        }),
    }),
  },
  smartCharging: {
    waitlist: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetSmartChargingWaitlistDocument),
    },
    eligibilityChecks: {
      queryKey: null,
      queryFn: () =>
        graphqlClient.request(GetSmartChargingEligibilityChecksDocument),
    },
    accounts: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetSmartChargingAccountsDocument),
    },
  },
  dcaConfiguration: {
    getConfiguration: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetDcaConfigurationDocument),
    },
  },
  syncAccounts: {
    search: (
      offset: number,
      limit: number,
      where: Junifer__Account_Bool_Exp,
      orderBy: Junifer__Account_Order_By,
    ) => ({
      queryKey: [offset, limit, JSON.stringify(where), JSON.stringify(orderBy)],
      queryFn: () =>
        graphqlClient.request(GetJuniferAccountsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    autoSyncedAccountsCount: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetAutoSyncedAccountsCountDocument),
    },
    syncedAccountNumbers: (where: Billing_Account_Bool_Exp) => ({
      queryKey: [JSON.stringify(where)],
      queryFn: () =>
        graphqlClient.request(GetSyncedAccountsNumbersDocument, { where }),
    }),
    userAccountNumbers: (email: string) => ({
      queryKey: [email],
      queryFn: () =>
        graphqlClient.request(GetUserAccountNumbersDocument, { email }),
    }),
  },
  testAccounts: {
    list: () => ({
      queryKey: ["testAccountsList"],
      queryFn: () => graphqlClient.request(GetFindTestAccountsDocument),
    }),
  },
  energyUsageLoadFactors: {
    alpsRange: (variables: GetAlpsRangeQueryVariables) => ({
      queryKey: [JSON.stringify(variables)],
      queryFn: () => graphqlClient.request(GetAlpsRangeDocument, variables),
    }),
  },
  emailVolumes: {
    list: (
      offset: number,
      limit: number,
      filters: Pick<
        GetAdminEmailListQueryVariables,
        "processedAt" | "communicationName"
      >,
    ) => ({
      queryKey: ["emailVolumesList", offset, limit, JSON.stringify(filters)],
      queryFn: () =>
        graphqlClient.request(GetAdminEmailListDocument, {
          offset,
          limit,
          ...filters,
        }),
    }),
    totalCount: (filters: GetAdminEmailTotalCountQueryVariables) => ({
      queryKey: ["emailVolumesTotalCount", JSON.stringify(filters)],
      queryFn: () =>
        graphqlClient.request(GetAdminEmailTotalCountDocument, filters),
    }),
    chartData: (filters: GetAdminEmailChartDataQueryVariables) => ({
      queryKey: ["emailVolumesChart", JSON.stringify(filters)],
      queryFn: () =>
        graphqlClient.request(GetAdminEmailChartDataDocument, filters),
    }),
    templates: () => ({
      queryKey: ["emailTemplates"],
      queryFn: () => graphqlClient.request(GetAdminEmailTemplatesDocument),
    }),
  },
  serviceConfig: {
    all: () => ({
      queryKey: ["serviceConfigAll"],
      queryFn: () => graphqlClient.request(GetBeFinancialsConfigListDocument),
    }),
    stats: () => ({
      queryKey: ["serviceConfigStats"],
      queryFn: () =>
        graphqlClient.request(GetBeFinancialsConfigStatsDocument, {
          now: formatServerDateTimeNow(),
        }),
    }),
    history: (name: string, limit: number, offset: number) => ({
      queryKey: ["serviceConfigHistory", name, limit, offset],
      queryFn: () =>
        graphqlClient.request(GetBeFinancialsConfigHistoryDocument, {
          name,
          limit,
          offset,
        }),
    }),
  },
  serviceJobs: {
    all: () => ({
      queryKey: ["serviceJobsAll"],
      queryFn: () => graphqlClient.request(GetBeFinancialsJobsListDocument),
    }),
  },
  emailTemplates: {
    summaries: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetEmailTemplateSummariesDocument),
    },
    byCommunication: (communicationId: number) => ({
      queryKey: [communicationId],
      queryFn: () =>
        graphqlClient.request(GetEmailTemplatesByCommunicationDocument, {
          communicationId,
        }),
    }),
    communications: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetCommunicationsDocument),
    },
    external: {
      queryKey: null,
      queryFn: () => graphqlClient.request(GetExternalEmailTemplatesDocument),
    },
    externalById: (id: number) => ({
      queryKey: [id],
      queryFn: () =>
        graphqlClient.request(GetExternalEmailTemplateByIdDocument, { id }),
    }),
  },
  tariffs: {
    forGsp: (gsp: string) => ({
      queryKey: [gsp],
      queryFn: () =>
        graphqlClient.request(GetTariffsDocument, { gsp_group: gsp }),
    }),
  },
  warrants: {
    jobs: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Job_Bool_Exp,
      orderBy: Financials_Warrants_Job_Order_By,
    ) => ({
      queryKey: [
        "warrantsJobs",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsJobsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    accounts: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Accounts_Bool_Exp,
      orderBy: Financials_Warrants_Accounts_Order_By,
    ) => ({
      queryKey: [
        "warrantsAccounts",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsAccountsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    whitelist: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Accounts_Whitelist_Bool_Exp,
      orderBy: Financials_Warrants_Accounts_Whitelist_Order_By,
    ) => ({
      queryKey: [
        "warrantsAccountsWhitelist",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsAccountsWhitelistDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    accountsHistory: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Accounts_History_Bool_Exp,
      orderBy: Financials_Warrants_Accounts_History_Order_By,
    ) => ({
      queryKey: [
        "warrantsAccountsHistory",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsAccountsHistoryDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    dcaQueue: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Dca_Queue_Bool_Exp,
      orderBy: Financials_Warrants_Dca_Queue_Order_By,
    ) => ({
      queryKey: [
        "warrantsDcaQueue",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsDcaQueueDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    dcaTickets: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Dca_Tickets_Bool_Exp,
      orderBy: Financials_Warrants_Dca_Tickets_Order_By,
    ) => ({
      queryKey: [
        "warrantsDcaTickets",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsDcaTicketsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    communicationGroups: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Communication_Group_Bool_Exp,
      orderBy: Financials_Warrants_Communication_Group_Order_By,
    ) => ({
      queryKey: [
        "warrantsCommunicationGroups",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsCommunicationGroupsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    communications: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Communications_Bool_Exp,
      orderBy: Financials_Warrants_Communications_Order_By,
    ) => ({
      queryKey: [
        "warrantsCommunications",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsCommunicationsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    filesJobs: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Files_Job_Bool_Exp,
      orderBy: Financials_Warrants_Files_Job_Order_By,
    ) => ({
      queryKey: [
        "warrantsFilesJobs",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsFilesJobsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    filesAccounts: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Files_Account_Bool_Exp,
      orderBy: Financials_Warrants_Files_Account_Order_By,
    ) => ({
      queryKey: [
        "warrantsFilesAccounts",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsFilesAccountsDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    filesProcessed: (
      offset: number,
      limit: number,
      where: Financials_Warrants_Files_Processed_Bool_Exp,
      orderBy: Financials_Warrants_Files_Processed_Order_By,
    ) => ({
      queryKey: [
        "warrantsFilesProcessed",
        offset,
        limit,
        JSON.stringify(where),
        JSON.stringify(orderBy),
      ],
      queryFn: () =>
        graphqlClient.request(GetWarrantsFilesProcessedDocument, {
          offset,
          limit,
          where,
          orderBy,
        }),
    }),
    filesAccountsSummary: (wheres: {
      pendingWhere: Financials_Warrants_Files_Account_Bool_Exp
      successWhere: Financials_Warrants_Files_Account_Bool_Exp
      failedWhere: Financials_Warrants_Files_Account_Bool_Exp
      returnsWhere: Financials_Warrants_Files_Account_Bool_Exp
      cancellationWhere: Financials_Warrants_Files_Account_Bool_Exp
    }) => ({
      queryKey: ["warrantsFilesAccountsSummary"],
      queryFn: () =>
        graphqlClient.request(GetWarrantsFilesAccountsSummaryDocument, wheres),
    }),
  },
})

export type HasuraQueryKeys = inferQueryKeyStore<typeof HasuraQueries>
